<div [ngSwitch]="documentType" class="document-viewer-container" [ngClass]="{'enforce-max-width': enforceMaxWidth}" >

    <app-footer-about *ngSwitchCase="DocumentType.About"></app-footer-about>
    <app-footer-support *ngSwitchCase="DocumentType.Support"></app-footer-support>
    <app-footer-terms *ngSwitchCase="DocumentType.TermsOfService"></app-footer-terms>
    <app-footer-privacy *ngSwitchCase="DocumentType.PrivacyPolicy"></app-footer-privacy>
    <app-pin-info *ngSwitchCase="DocumentType.PinInfo"></app-pin-info>
    <app-config-viewer *ngSwitchCase="DocumentType.Configuration" [data]="data"></app-config-viewer>

</div>

